import { render, staticRenderFns } from "./CreateSuccess.vue?vue&type=template&id=575bd168&scoped=true"
import script from "./CreateSuccess.vue?vue&type=script&lang=js"
export * from "./CreateSuccess.vue?vue&type=script&lang=js"
import style0 from "./CreateSuccess.vue?vue&type=style&index=0&id=575bd168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575bd168",
  null
  
)

export default component.exports